module.exports = __webpack_public_path__ + "static/media/Smaragdenia_Filaki_3.d5a1ff08.jpg";